/**
 * Runs the startup session restore — WITHOUT blocking the first paint.
 *
 * Previously this component withheld <RouterProvider> until `/auth/me`
 * resolved, so the whole app was a centered spinner for the entire round-trip
 * (up to the 15s api-client timeout on a cold backend).
 *
 * Now it only kicks off the restore. The router renders immediately; the
 * protected subtree waits on `status === "checking"` (see `RequireSession`),
 * which shows the app skeleton. Public routes (login, portal, shared report)
 * are therefore reachable instantly and are never gated behind auth.
 */

import type { ReactNode } from "react";
import { useSessionRestore } from "@/features/auth/useSessionRestore";

export function SessionGate({ children }: { children: ReactNode }) {
  useSessionRestore();
  return <>{children}</>;
}
